module.exports = require('./dist/next-server/lib/runtime-config')
